import PropTypes from 'prop-types';
import React from 'react';
import cn from 'classnames';

import './Divider.scss';

/**
 * Dividers that do not semantically represent a change in section/topic
 * should be marked as presentational.
 */
export default function Divider({ className, presentational }) {
  const Tag = presentational ? 'div' : 'hr';
  const classNames = cn('cp-divider', className);

  return <Tag className={classNames} aria-hidden />;
}

Divider.propTypes = {
  className: PropTypes.string,
  presentational: PropTypes.bool
};
